import Title from "antd/lib/typography/Title";
import { toTitleCase } from "../../../utils/commonfunction";

export default function ProductionSummaryTemp(props) {
  const thCss = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    color: "black",
  };
  const thCssHead = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    background: "#4561b9",
    color: "white",
    fontWeight: "bold",
  };
  const headRow = {
    display: "table-row",
    fontWeight: "900",
    color: "#ffffff",
  };

  const list = props?.list || [];
  const headList = props.headList || (list.length > 0 ? Object.keys(list[0]) : []);

  return (
    <div style={{ border: "1px solid gray", padding: 20, width: "100%" }}>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        id="table-to-xls"
      >
        <tr>
          <td colSpan={headList?.length || 6}>
            <Title level={4} style={{ textAlign: "center" }}>
              Production Summary: {props.branch} - {props.department}
            </Title>
          </td>
        </tr>
        <tr>
          <td colSpan={headList?.length || 6}>
            <Title level={5} style={{ textAlign: "center" }}>
              {props.date}
            </Title>
          </td>
        </tr>
        {headList?.length > 0 && (
          <tr style={headRow}>
            {headList.map((x) => (
              <td key={x} style={thCssHead}>
                {toTitleCase(x || "")}
              </td>
            ))}
          </tr>
        )}
        <tbody>
          {list.map((row, index) => (
            <tr key={index} style={{ pageBreakInside: "avoid" }}>
              {headList.map((col) => (
                <td key={col} style={thCss}>
                  {row[col]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
